export default "__VITE_ASSET__CR6Vy0GG__"